import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

type Variant = 'primary' | 'warning' | 'success' | 'danger';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss']
})
export class StatCardComponent {
  /** Two-line title like: "Total\nDeliveries" */
  @Input() title = '';
  /** Big number on the left */
  @Input() value: number | string = 0;
  /** Material icon name (e.g., 'local_shipping', 'schedule', 'inventory_2') */
  @Input() icon = 'info';
  /** Color scheme for the circular badge */
  @Input() variant: Variant = 'primary';

  /** Optional: small aria-label for accessibility */
  @Input() ariaLabel = '';

  get hostClasses() {
    return {
      ['v-' + this.variant]: true
    };
  }
}
